import { useParams } from "react-router-dom";
import { BreadcrumbChild } from "../../../../components/BreadcrumbCustom/BreadcrumbCustom";
import { StyledIcon } from "../../../../components/StyledIcon/StyledIcon";
import { routesConfig } from "../../../../config/routes";
import { CreateScheduleForm } from "../../shared/CreateScheduleForm";
import { StorageProvider } from "../../../../contexts/storage/storage-provider";

const CreatePumpingRequest: React.FC = () => {
  const { id } = useParams();
  const isEditing = Boolean(id);
  const breadcrumbs: BreadcrumbChild[] = [
    { isIcon: true, icon: <StyledIcon iconType="home" /> },
    {
      label: "Entregas",
      link: routesConfig.STORAGE().PIPELINES,
    },
    {
      label: `${isEditing ? "Editar" : "Novo"} pedido de entrega`,
    },
  ];

  return (
    <StorageProvider>
      <CreateScheduleForm breadcrumbs={breadcrumbs} />
    </StorageProvider>
  );
};

export default CreatePumpingRequest;
